<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-item-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <div
      :class="['items', {
        'items--three': items.length === 3,
        'items--two': items.length === 2,
        'items--one': items.length === 1,
      }]"
    >
      <zg-item-solo
        v-for="(item, index) in items"
        :key="item.contentId || index"
        v-bind="item"
        class="item"
      />
    </div>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgItemSolo from '../../ZgItemSolo/ZgItemSolo.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgItemSection',
    components: {
      ZgModule,
      ZgItemSolo
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .items {
    display: flex;
    flex-direction: column;
    gap: rem(48px);

    @include mq(medium) {
      flex-direction: row;
    }

    &--three {
      .item {
        width: 100%;

        @include mq(medium) {
          width: calc(100% / 3);
        }
      }
    }

    &--two {
      .item {
        width: 100%;

        @include mq(medium) {
          width: calc(100% / 2);
        }
      }
    }

    &--one {
      .item {
        width: 100%;

        @include mq(medium) {
          width: calc(100% / 1);
        }
      }
    }
  }
</style>
